import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { authAPI } from "../../api/auth/auth"

const initialState = {
    status: null,
    error: null,
    resetPasswordStatus: null,
    resetPasswordError: null,
    confirmResetPasswordStatus: null,
    confirmResetPasswordError: null,
    authenticated: false,
    requireAuthentication: false,
}

export const authenticationThunk = createAsyncThunk(
    "authentication/authenticationThunk",
    async({email, password}, {rejectWithValue})  => {
        const resp = await authAPI.authenticate(email, password)
        if (resp.ok) {
            return {
                "ok": true
            }
        }
        if(resp.err) {
            return rejectWithValue({"err": resp.err})
        }
        return rejectWithValue({"err": 'something_went_wrong'})
    }
)

export const resetPasswordThunk = createAsyncThunk(
    "authentication/resetPasswordThunk",
    async({email, language}, {rejectWithValue})  => {
        const resp = await authAPI.resetPassword(email, language)
        if (resp.ok) {
            return {
                "ok": true
            }
        }
        if(resp.err) {
            return rejectWithValue({"err": resp.err})
        }
        return rejectWithValue({"err": 'something_went_wrong'})
    }
)

export const confirmResetPasswordThunk = createAsyncThunk(
    "authentication/confirmResetPasswordThunk",
    async({password, token}, {rejectWithValue})  => {
        const resp = await authAPI.confirmResetPassword(password, token)
        if (resp.ok) {
            return {
                "ok": true
            }
        }
        if(resp.err) {
            return rejectWithValue({"err": resp.err})
        }
        return rejectWithValue({"err": 'something_went_wrong'})
    }
)

const authenticationSlice = createSlice({
    name: "authentication",
    initialState,
    reducers: {
        setAuthenticated(state, action) {
            state.authenticated = action.payload
        },
        requireAuthentication(state) {
            state.requireAuthentication = true;
        },
        setRequireAuthenticationToFalse(state) {
            state.requireAuthentication = false;
        },
        setResetPasswordStatus(state, action) {
            state.resetPasswordStatus = action.payload
        }
    },
    extraReducers(builder) {
        builder.addCase(authenticationThunk.fulfilled, (state, action) => {
            state.authenticated = true
            state.requireAuthentication = false
            state.status = 'fulfilled'
            state.error = null
        })
        builder.addCase(authenticationThunk.pending, (state, action) => {
            state.authenticated = false
            state.status = 'pending'
            state.error = null
        })
        builder.addCase(authenticationThunk.rejected, (state, action) => {
            const {err} = action.payload
            state.authenticated = false
            state.status = 'rejected'
            
            if(err) {
                state.error = err
                return
            }

            state.error = 'something_went_wrong'
        })

        builder.addCase(resetPasswordThunk.fulfilled, (state, action) => {
            state.resetPasswordStatus = 'fulfilled'
            state.resetPasswordError = null
        })
        builder.addCase(resetPasswordThunk.pending, (state, action) => {
            state.resetPasswordStatus = 'pending'
            state.resetPasswordError = null
        })
        builder.addCase(resetPasswordThunk.rejected, (state, action) => {
            const {err} = action.payload
            state.resetPasswordStatus = 'rejected'
            
            if(err) {
                state.resetPasswordError = err
                return
            }

            state.resetPasswordError = 'something_went_wrong'
        })

        builder.addCase(confirmResetPasswordThunk.fulfilled, (state, action) => {
            state.confirmResetPasswordStatus = 'fulfilled'
            state.confirmResetPasswordError = null
        })
        builder.addCase(confirmResetPasswordThunk.pending, (state, action) => {
            state.confirmResetPasswordStatus = 'pending'
            state.confirmResetPasswordError = null
        })
        builder.addCase(confirmResetPasswordThunk.rejected, (state, action) => {
            const {err} = action.payload
            state.confirmResetPasswordStatus = 'rejected'
            
            if(err) {
                state.confirmResetPasswordError = err
                return
            }

            state.confirmResetPasswordError = 'something_went_wrong'
        })

    }
})

export const selectAuthenticationStatus = (state) => state.authentication.status
export const selectAuthenticationError = (state) => state.authentication.error
export const selectResetPasswordStatus = (state) => state.authentication.resetPasswordStatus
export const selectResetPasswordError = (state) => state.authentication.resetPasswordError
export const selectConfirmResetPasswordStatus = (state) => state.authentication.confirmResetPasswordStatus
export const selectConfirmResetPasswordError = (state) => state.authentication.confirmResetPasswordError

export const selectAuthenticated = (state) => state.authentication.authenticated
export const selectRequireAuthentication = (state) => state.authentication.requireAuthentication

export const { setAuthenticated, requireAuthentication, setRequireAuthenticationToFalse, setResetPasswordStatus } = authenticationSlice.actions

export default authenticationSlice.reducer